import {
  FormTemplate as Data,
  FormTemplateCollection as Collection,
} from '@/typings/api/FormTemplate'

import { DataCollection } from '@/typings/api/DataCollection'

import { BaseApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'


export class DataCollectionsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'data-collection/data-collections';

  public getCurated(config?: AxiosRequestConfig) {
    const path = 'curated/'
    const [url] = this.getUrl(path)
    return this.request('GET', url, config)
  }

  public addParticipants(id: DataCollection['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/add-participants/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public removeParticipants(id: DataCollection['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/remove-participants/`
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }
}
